<template>
  <el-table
    id="instance-plans"
    ref="plans"
    :data="data"
    :default-sort="defaultSort"
    :row-class-name="selected"
    :size="size"
  >
    <el-table-column
      label="Provider"
      prop="provider.name"
      width="160px"
      sortable
    >
      <template slot-scope="scope">
        <h4>
          {{ scope.row.provider.name }}
        </h4>
        <small v-if="hasMultipleDC(scope.row)" class="gray">
          <em>DC : {{ scope.row.provider.datacenter.toLowerCase() }}</em>
        </small>
      </template>
    </el-table-column>

    <el-table-column label="Type" prop="name" sortable>
      <template slot-scope="scope">
        <el-tag :type="getInstanceType(scope.row.name)" size="mini">
          {{ scope.row.name }}
        </el-tag>
      </template>
    </el-table-column>

    <el-table-column label="Configuration" prop="memory" sortable>
      <template slot-scope="scope">
        <div>
          <strong>{{ planDescription(scope.row.id, true) }}</strong>
        </div>
        <div v-if="scope.row.sandbox">
          <small>Built-in storage : {{ scope.row.storage }} GB</small>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      v-if="permission('owner') || permission('admin')"
      label="Price"
      prop="price.month"
      :sort-method="sortPrice"
      sortable
    >
      <template slot-scope="scope">
        <div class="price-month">
          <sup>{{ $root.currency.symbol }}</sup><strong>{{ getMonthPrice(scope.row.price).replace(/([0-9]{2})$/, '') }}</strong>/month
        </div>
        <div class="price-hour">
          {{ $root.currency.symbol }}{{ getHourPrice(scope.row.price).replace(/([0-9]{3})$/, '.$1') }}/hour
        </div>
      </template>
    </el-table-column>

    <el-table-column align="right" width="120px">
      <template slot-scope="scope">
        <el-tag
          v-if="scope.row.id === planId"
          type="default"
          :disable-transitions="true"
        >
          <i class="el-icon-check" /> Selected
        </el-tag>

        <el-button
          v-else
          type="info"
          size="small"
          @click="$emit('update:planId', scope.row.id)"
        >
          Choose
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    planId: String,
    data: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: 'mini'
    },
    storageSize: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      defaultSort: {
        prop: 'price.month',
        order: 'ascending'
      }
    }
  },
  computed: mapGetters(['permission']),
  methods: {
    sortPrice (a, b) {
      return parseInt(a.price.month) - parseInt(b.price.month)
    },
    getHourPrice (price) {
      const hour = parseInt(price.hour)
      return Math.ceil(hour + (this.storageFee(this.storageSize) * 10 / 744)).toString().padStart(4, 0)
    },
    getMonthPrice (price) {
      const month = parseInt(price.month)
      return (month + this.storageFee(this.storageSize)).toString().padStart(3, 0)
    },
    getInstanceType (name) {
      const type = (name || '').toLowerCase().split(' ').shift()
      switch (type) {
        case 'testing':
        case 'sandbox':
        case 'development':
          return 'info'
        case 'basic':
          return 'default'
        default:
          return 'danger'
      }
    },
    hasMultipleDC (plan) {
      return this.data.filter((p) => p.provider.name === plan.provider.name &&
        p.name === plan.name && p.vcpus === plan.vcpus && p.memory === plan.memory).length > 1
    },
    selected ({ row }) {
      if (row.id === this.planId) {
        return 'selected'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  h4 {
    margin: 0;
  }

  .gray {
    color: #aaa;
  }

  .provider {
    max-height: 30px;
  }

  .price-month {
    font-size: 14px;
    line-height: 18px;

    strong {
      font-size: 18px;
      padding: 0 2px;
    }
    sup {
      position: relative;
      top: 5px;
    }
  }
  .price-hour {
  }
</style>

<style lang="scss">
  @import "../../theme";

  #instance-plans {
    .selected td, .selected td:hover {
      background-color: $--color-primary-alt !important;
      color: white;

      .gray {
        color: white;
      }
    }
  }
</style>
